import type { PanelFilters } from '@content-search/domain';
import { Select } from '@soteria/design-system-ve';
import { useCallback } from 'react';

import * as styles from './FilterPanel.css';

interface SamplingFilterProps {
  panelFilters: PanelFilters;
  updateFilters: (updates: Partial<PanelFilters>) => void;
  isLoading: boolean;
}

const SAMPLING_OPTIONS = [
  { value: 'sampled', label: 'Sampled' },
  { value: 'not_sampled', label: 'Not Sampled' },
];

export function SamplingFilter({ panelFilters, updateFilters, isLoading }: SamplingFilterProps) {
  const handleSamplingChange = useCallback(
    (value: string) => {
      let isSampled: boolean | undefined;

      if (value === 'sampled') {
        isSampled = true;
      } else if (value === 'not_sampled') {
        isSampled = false;
      } else {
        isSampled = undefined;
      }

      updateFilters({ isSampled });
    },
    [updateFilters]
  );

  const samplingValue = panelFilters.isSampled === true ? 'sampled' : panelFilters.isSampled === false ? 'not_sampled' : 'all';

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterLabel}>Sampling</div>
      <Select aria-label="Filter by sampling" disabled={isLoading} options={SAMPLING_OPTIONS} value={samplingValue} onChange={handleSamplingChange} />
    </div>
  );
}
